<form>
  <div class="lv-modal-dialog">
    <div mat-dialog-title class="lv-dialog-header">
      <div class="lv-dialog-header-title">
        Details zu {{ data.item.WertAnzeige }}
      </div>
      <div class="lv-dialog-icon-close">
        <mat-icon [svgIcon]="'Times'" (click)="closeDialog()"></mat-icon>
      </div>
    </div>
    <div *ngIf="(showSpinner$ | async)" class="lv-dialog-content-spinner">
      <mat-progress-spinner class="lv-progress-spinner-primary" mode="indeterminate" [diameter]="50"></mat-progress-spinner>
    </div>
    <ng-container *ngIf="uiModul$ | async as uiModul">
      <div mat-dialog-content class="lv-dialog-content">
        <lv-uiartefakt-container [uiArtefakte]="uiModul.UIArtefakt"></lv-uiartefakt-container>
      </div>
    </ng-container>
    <div *ngIf="(showSpinner$ | async) === false">
      <div class="lv-dialog-buttons" mat-dialog-actions align="end">
        <button mat-raised-button color="accent" (click)="closeDialog()">
          {{ 'MODAL_DIALOG.BUTTON_ABBRECHEN' | translate }}
        </button>
        <button mat-raised-button color="primary" class="lv-primary-button" (click)="onUebernehmenClicked()">
          {{ 'MODAL_DIALOG.UEBERNEHMEN' | translate }}
        </button>
      </div>
    </div>
  </div>
</form>
